// MainExaminationScoreWrapper.tsx

import React, { useEffect, useState } from "react"
import { BorderedButton } from "src/components/Button"
import { MainExaminationScore as MainExaminationScoreType } from "src/hooks/useMainExaminationScoresSWR"
import { useSmoothApi } from "src/hooks/useSmoothApi"
import { SMOOTH_SMOOTHER_API_URL } from "src/lib/constants"
import { ForCICProps, User as UserType, Proposal as ProposalType } from "./ForCIC"
import { MainExaminationScore } from "./MainExaminationScore"
import { MainExaminationScoreSimple } from "./MainExaminationScoreSimple"

type MainExaminationScoreWrapperProps = {
  mes: MainExaminationScoreType
  props: ForCICProps
}

export const MainExaminationScoreWrapper: React.FC<MainExaminationScoreWrapperProps> = ({
  mes,
  props,
}) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const [additionalData, setAdditionalData] = useState<{
    proposal: ProposalType
    user: UserType
  } | null>(null)
  const [loading, setLoading] = useState(false)
  const { getWithToken } = useSmoothApi()

  const handleExpand = () => {
    setIsExpanded(true)
  }

  useEffect(() => {
    if (isExpanded && !additionalData) {
      setLoading(true)
      // Fetch necessary data
      const fetchData = async () => {
        try {
          const url = `${SMOOTH_SMOOTHER_API_URL}/for_cic/additional_data?mes_id=${mes.id}`
          const res = await getWithToken(url)
          const data = res.data
          console.log(data)

          const movingApplicationData = data.moving_application
          const proposalData = data.proposal
          const userData = data.user

          setAdditionalData({
            proposal: proposalData,
            user: userData,
          })
        } catch (error) {
          console.error("Error fetching data", error)
        } finally {
          setLoading(false)
        }
      }
      fetchData()
    }
  }, [isExpanded, additionalData])

  if (isExpanded) {
    if (loading) {
      return <div>Loading...</div>
    } else if (additionalData) {
      return (
        <MainExaminationScore
          key={mes.id}
          user={additionalData.user}
          mes={mes}
          proposal={additionalData.proposal}
          {...props}
          className={null}
        />
      )
    }
  }

  if (mes.user == null) {
    return <div>.</div>
  }

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "end",
        }}
      >
        <BorderedButton
          onClick={handleExpand}
          style={{
            backgroundColor: "white",
          }}
        >
          追加読み込み
        </BorderedButton>
      </div>
      <MainExaminationScoreSimple
        key={mes.id}
        user={mes.user}
        mes={mes}
        {...props}
        className={null}
      />
    </div>
  )
}
